import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const ChatBubbleLeftIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/chat-bubble-left"><path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M4.11566 3.02839C6.68327 2.61476 9.31684 2.3999 12 2.3999C14.6831 2.3999 17.3166 2.61476 19.8842 3.02839C21.6079 3.30606 22.8 4.8158 22.8 6.51096V12.6888C22.8 14.384 21.6079 15.8937 19.8842 16.1714C17.8496 16.4992 15.7736 16.7021 13.6643 16.7722C13.4197 16.7804 13.1943 16.8784 13.0312 17.0414L8.73635 21.3363C8.47895 21.5937 8.09184 21.6707 7.75554 21.5314C7.41923 21.3921 7.19995 21.0639 7.19995 20.6999V16.5687C6.16215 16.4682 5.13372 16.3354 4.11567 16.1714C2.39202 15.8937 1.19995 14.384 1.19995 12.6888V6.51096C1.19995 4.8158 2.39202 3.30606 4.11566 3.02839Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ChatBubbleLeftIcon;